import { AnimatedNumber } from 'components/common/v2';
import { isNil } from 'lib/javascript';

interface ProductNutrientProps {
  name: string;
  value: number;
  fontSize?: 'sm' | 'md' | 'lg';
  unit?: string;
}

const formatNutritionValue = (value: number) => {
  if (isNaN(value)) return String(value);

  return String(
    new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(value),
  );
};

const ProductNutrient = ({
  name,
  value,
  fontSize = 'sm',
  unit,
}: ProductNutrientProps) => {
  const nameWithUnit = [name, unit && `(${unit})`]
    .filter((el) => !!el)
    .join(' ');

  const fontSizeClass = (() => {
    switch (fontSize) {
      case 'sm':
        return 'tw-text-[0.925rem] sm:tw-text-[1.1rem] md:tw-text-[1.125rem] xl:tw-text-[1.25rem]';
      case 'md':
        return 'tw-text-[1.1rem] sm:tw-text-[1.2rem] md:tw-text-[1.3rem] xl:tw-text-[1.5rem]';
      case 'lg':
        return 'tw-text-[1.25rem] sm:tw-text-[1.5rem] md:tw-text-[1.625rem] xl:tw-text-[1.75rem]';
    }
  })();

  return (
    <div className="tw-flex tw-flex-col tw-gap-1">
      <span
        className={`tw-whitespace-nowrap tw-mb-0 tw-font-bold tw-leading-none tw-text-[#333] ${fontSizeClass}`}
      >
        {isNil(value) ? (
          'N/A'
        ) : (
          <AnimatedNumber
            value={value}
            format={formatNutritionValue}
          />
        )}
      </span>
      <span className="tw-leading-none tw-whitespace-nowrap tw-text-[#666] tw-font-light tw-text-[0.925rem] sm:tw-text-[1.1rem] md:tw-text-[1.125rem] tw-tracking-tighter">
        {nameWithUnit}
      </span>
    </div>
  );
};

export default ProductNutrient;
